import * as types from './types';
import { INTEGRATIONS } from '../constants';
/**
 * INTEGRACION AVISOS
 */
const listIntegrators = (integrationType = INTEGRATIONS.XML) => ({
  type: types.LIST_INTEGRATORS,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: `/v1/integrators?mode=${integrationType}`,
    method: 'GET'
  },
  payload: {
    integrationType
  }
});

const getSubCompanies = () => ({
  type: types.GET_SUB_COMPANIES,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: '/v1/companies/branches',
    method: 'GET'
  }
});

const upsertIntegration = payload => ({
  type: types.UPSERT_INTEGRATION,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: '/v1/integrations',
    body: payload,
    method: 'POST'
  }
});

const getCurrentIntegration = companyId => ({
  type: types.GET_CURRENT_INTEGRATION,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: `/v1/integrations/${companyId}/current?type=LECTURA_ESCRITURA`,
    method: 'GET'
  }
});

const removeXMLIntegration = (companyId, interfaceId) => ({
  type: types.REMOVE_XML_INTEGRATION,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: `/v1/integrations?companyId=${companyId}&interfaceId=${interfaceId}&type=xml`,
    method: 'DELETE'
  }
});

const clearCurrentIntegration = () => ({
  type: types.CLEAR_CURRENT_INTEGRATION
});

const clearUpsertIntegration = () => ({
  type: types.CLEAR_UPSERT_INTEGRATION
});

/**
 * INTEGRACION LEADS
 */

const listLeadsIntegrators = () => ({
  type: types.LIST_LEADS_INTEGRATORS,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: '/v1/integrators?mode=leads',
    method: 'GET'
  }
});

const getLeadsSubCompanies = () => ({
  type: types.GET_LEADS_COMPANY_BRANCHES,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: '/v1/companies/branches',
    method: 'GET'
  }
});

const getCurrentLeadsIntegration = companyId => ({
  type: types.GET_CURRENT_LEADS_INTEGRATIONS,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: `/v1/integrations/${companyId}/current?type=ALL`,
    method: 'GET'
  }
});

const addLeadsIntegration = payload => ({
  type: types.ADD_LEADS_INTEGRATION,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: '/v1/integrations/leads',
    body: payload,
    method: 'POST'
  }
});

const removeLeadsIntegration = (companyId, interfaceId) => ({
  type: types.REMOVE_LEADS_INTEGRATION,
  meta: {
    async: true,
    blocking: false,
    api: 'integraciones',
    path: `/v1/integrations?companyId=${companyId}&interfaceId=${interfaceId}&type=leads`,
    method: 'DELETE'
  }
});

const clearCurrentLeadsIntegrations = () => ({
  type: types.CLEAR_CURRENT_LEADS_INTEGRATIONS
});

const clearAddedLeadsIntegration = () => ({
  type: types.CLEAR_ADDED_LEADS_INTEGRATION
});

const clearRemovedLeadsIntegration = () => ({
  type: types.CLEAR_REMOVED_LEADS_INTEGRATION
});

export {
  listIntegrators,
  getSubCompanies,
  upsertIntegration,
  getCurrentIntegration,
  removeXMLIntegration,
  clearCurrentIntegration,
  clearUpsertIntegration,
  listLeadsIntegrators,
  getCurrentLeadsIntegration,
  getLeadsSubCompanies,
  addLeadsIntegration,
  removeLeadsIntegration,
  clearAddedLeadsIntegration,
  clearCurrentLeadsIntegrations,
  clearRemovedLeadsIntegration
};
